import { FC } from "react";
import CustomSwitch from "@shared-ui-components/CustomSwitch";
import { ListItemWrapper } from "../style";

interface ListItemProps {
  handleChange: () => void;
  checked: boolean;
  label: string;
}

const ListItem: FC<ListItemProps> = ({ label, handleChange, checked }) => {
  return (
    <ListItemWrapper>
      {label}
      <CustomSwitch checked={checked} handleChange={handleChange} />
    </ListItemWrapper>
  );
};

export default ListItem;
